import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Slide from 'react-reveal/Slide'
import get from 'lodash.get'

import Image from 'components/atoms/Image'
import CardTopics from 'components/molecules/CardTopics'
import { getNameColorFromHex, userCheckMobileScreen } from 'helpers/tools'

import './HtmlItemListImage.scss'

function HtmlItemListImage({ data }) {
  const image = userCheckMobileScreen()
    ? get(data, 'image.entity.images.large.url')
    : get(data, 'image.entity.images.wide.url')
  const alt = get(data, 'image.entity.images.alt')
  const title = get(data, 'title')
  const imageSide = get(data, 'imageAlignment')
  const backgroundColor = get(data, 'primaryColor.entity.fieldColor[0].color', '')
  const secondaryColor = get(data, 'secondaryColor.entity.fieldColor[0].color', '')
  const linkUrl = get(data, 'button.entity.link.url.path')
  const linkIcon = get(data, 'button.entity.linkType.entity.token', 'arrow-right')
  const linkText = get(data, 'button.entity.link.title')

  return (
    <div className="HtmlItemListImage">
      <Container fluid="fluid" className={`bg-${getNameColorFromHex(backgroundColor)} top-section`}>
        <Container>
          <Row className={`out-container ${imageSide === 'right' && 'flex-column-reverse flex-lg-row'}`}>
            {imageSide === 'left' && (
              <Col sm={12} lg={5} className="pb-4 pb-lg-0 reveal-image">
                <Slide bottom>
                  <Image src={image} alt={alt} shadow={true} roundedCorners={true} adjustMob={true} fullImage />
                </Slide>
              </Col>
            )}

            <Col sm={12} lg={7} className="pb-4 pb-lg-0 reveal-card">
              <Slide bottom>
                <CardTopics
                  color="secondary"
                  header={title}
                  topics={data.items.map(({ entity }) => ({
                    key: get(entity, 'id') + get(entity, 'uuid'),
                    value: get(entity, 'description.value'),
                    icon: get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url'),
                  }))}
                  footer={
                    linkText && {
                      cta: {
                        text: linkText,
                        url: linkUrl,
                        icon: linkIcon,
                        iconAlign: 'right',
                      },
                    }
                  }
                />
              </Slide>
            </Col>

            {imageSide === 'right' && (
              <Col sm={12} lg={5} className="pb-4 pb-lg-0 reveal-image">
                <Slide bottom>
                  <Image src={image} alt={alt} shadow={true} roundedCorners={true} adjustMob={true} fullImage />
                </Slide>
              </Col>
            )}
          </Row>
        </Container>
      </Container>
      <Container fluid="fluid" className={`bg-${getNameColorFromHex(secondaryColor)} bottom-section`} />
    </div>
  )
}

export default HtmlItemListImage
